// Suppress console in production (import this first in index.js)
if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
  const noop = () => {};
  ['log', 'warn', 'info', 'debug', 'trace'].forEach((method) => {
    if (console[method]) console[method] = noop;
  });
}
